import { render, staticRenderFns } from "./deactivateProvider.vue?vue&type=template&id=793a4005"
import script from "./deactivateProvider.vue?vue&type=script&lang=js"
export * from "./deactivateProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports